export enum EquipmentAlertType {
  FUTURE_PASSAGE = 'FUTURE_PASSAGE',
  SEND_SERVER_FAIL = 'SEND_SERVER_FAIL',
  EQUIPMENT_TO_SERVER_DELAY = 'EQUIPMENT_TO_SERVER_DELAY',
  DATA_TO_SERVER_DELAY = 'DATA_TO_SERVER_DELAY',
  LOW_RELIABILITY = 'LOW_RELIABILITY',
  LANE_WITHOUT_OCR = 'LANE_WITHOUT_OCR',
  SEQUENCE_WITHOUT_OCR = 'SEQUENCE_WITHOUT_OCR',
}
